const vStopPropagation = {
  mounted: function (el: HTMLElement) {
    el.addEventListener('keydown', (e) => e.stopPropagation());
    el.addEventListener('paste', (e) => e.stopPropagation());
    el.addEventListener('copy', (e) => e.stopPropagation());
  },
  unmounted: function (el: HTMLElement) {
    el.removeEventListener('keydown', (e) => e.stopPropagation());
    el.removeEventListener('paste', (e) => e.stopPropagation());
    el.removeEventListener('copy', (e) => e.stopPropagation());
  },
};

export default vStopPropagation;
